import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { ReactiveFormsModule } from '@angular/forms';
import { CoreModule } from 'app/core/core.module';
import { SharedModule } from 'app/shared';
import { InvoicesPageContainer } from './invoices-page-container/invoices-page-container.component';

import { InvoicesRoutingModule } from './invoices-routing.module';
import { InvoicesFilterComponent } from './invoices-filter/invoices-filter.component';

@NgModule({
  imports: [CommonModule, InvoicesRoutingModule, SharedModule, CoreModule, ReactiveFormsModule],
  declarations: [InvoicesPageContainer, InvoicesFilterComponent],
})
export class InvoicesModule {}
